<template>
    <div class="view-wrapper full-wrapper view-wrapper-with-footer bg">
        <div></div>
        <div class="section">
            <div class="header">
                <div class="fill-height flex-ui-row center-align">
                    <a @click="$router.go(-1)" class="header-btn">
                        <van-icon name="arrow-left" />
                    </a>
                    <div class="header-center"></div>
                    <van-popover v-model="showPopover" placement="bottom-end" theme="dark" :offset="[12, 8]"
                        :actions="actions" @select="popSelect">
                        <template #reference>
                            <div class="header-btn" @click="showPop">
                                <van-icon name="ellipsis" />
                            </div>
                        </template>
                    </van-popover>
                </div>
            </div>
            <van-swipe indicator-color="white" class="swipe-h">
                <van-swipe-item>
                    <img :src="product.ProImage" alt />
                </van-swipe-item>
            </van-swipe>
        </div>
        <div class="section-padding">
            <div class="goods-name">{{ product.ProName }}</div>
            <div class="goods-intro">{{ product.ProIntro }}</div>
            <div class="goods-price">
                <span class="suffix">&yen;</span>
                <span v-if="skuSelected" class="price">{{
                    sku.skuPrice | num2Filter
                }}
                </span>
                <span v-else>
                    <span class="price">{{
                        product.ProPrice | num2Filter
                    }}</span>
                    <span class="suffix"></span>
                </span>
                <template>
                    <span v-if="skuSelected && sku.skuPrice !== sku.skuOriginalPrice" class="unprice"> &yen; {{
                        sku.skuOriginalPrice | num2Filter
                        }}
                    </span>
                    <span v-if="!skuSelected && product.ProPrice !== product.OriginalPrice">
                        <span class="unprice"> &yen;{{
                            product.OriginalPrice | num2Filter
                            }}</span>
                    </span>
                </template>
                <van-tag v-if="product.OrderLimit > 0" plain round type="success" class="goods-tag">每位用户总限购{{
                    product.OrderLimit
                }}件</van-tag>
            </div>
        </div>
        <div class="section section-border">
            <van-cell-group>
                <van-cell title="已选" is-link @click="confirmSku">
                    <template slot="title">
                        <span class="cell-tit">已选</span>
                        <span class="cell-value" v-if="skuSelected">{{ sku.skuName }} x {{ sku.count }}</span>
                        <span class="cell-value" v-else>请选择</span>
                    </template>
                </van-cell>
            </van-cell-group>
        </div>
        <div v-html="product.ProDesc" class="goods-desc section-border"></div>
        <van-popup v-model="showChoise" round position="bottom" :style="{ height: '70%' }" @closed="onClose">
            <div class="sku-container">
                <div class="sku-header van-hairline--bottom">
                    <div class="sku-img">
                        <img :src="product.ProImage" alt />
                    </div>
                    <div class="sku-goods-info">
                        <div v-if="skuSelected">
                            <span class="sku-header-price"> &yen;{{ sku.skuPrice }}</span>
                            <span class="sku-header-unprice" v-if="sku.skuPrice !== sku.skuOriginalPrice"> &yen;{{ sku.skuOriginalPrice }}</span>
                        </div>
                        <div v-else>
                            <span class="sku-header-price"> &yen;{{ product.ProPrice }}</span>
                            <span class="sku-header-unprice" v-if="product.ProPrice !== product.OriginalPrice"> &yen;{{ product.OriginalPrice }}</span>
                        </div>
                        <div class="sku-header-item" v-if="skuSelected && sku.remain > 0">
                            剩余 {{ sku.remain }}
                        </div>
                        <div class="sku-header-item" v-if="skuSelected">
                            已选: {{ sku.skuName }} x {{ sku.count }}
                        </div>
                        <van-icon name="clear" class="sku-close-icon" @click="showChoise = false" />
                    </div>
                </div>
                <div class="sku-body">
                    <div class="sku-stock-container">
                        <div class="sku-row van-hairline--bottom">
                            <div class="sku-row-tit">规格</div>
                            <span class="sku-row-item" v-for="item in product.ProSkuList" :key="'sku' + item.StockId"
                                :class="{
                                    'sku-row-item--active': isActive(
                                        item.StockId
                                    ),
                                    'sku-row-item--disabled': isDisabled(item),
                                }" @click="selectSku(item)">{{ item.StockName }}</span>
                        </div>
                    </div>
                    <div class="sku-stepper-container van-hairline--bottom">
                        <div class="sku-stepper-stock">
                            <div class="sku-stepper-tit">数量</div>
                            <div class="sku-stepper">
                                <van-stepper v-model="sku.count" integer :min="product.MinNum" :max="product.MaxNum > 0
                                    ? product.MaxNum
                                    : 1000
                                    " />
                            </div>
                        </div>
                    </div>
                </div>
                <div class="sku-btns" v-if="salable">
                    <van-button round size="large" type="danger" @click="confirmBuy" class="btn-default">确认</van-button>
                </div>
            </div>
        </van-popup>
        <van-goods-action class="goods-actions">
            <van-goods-action-icon icon="cart-o" to="/cart" v-if="product.ProType === 1" :badge="cartCount"
                text="购物车" />
            <van-goods-action-button type="warning" v-if="product.ProType === 1" @click="addCart" text="加入购物车"
                :disabled="!salable" />
            <van-goods-action-button v-if="salable" type="danger" text="立即购买" @click="goBuy" :disabled="!salable" />
            <van-goods-action-button v-else type="danger" text="已售罄" :disabled="!salable" />
        </van-goods-action>
        <SharePopup v-model="share"></SharePopup>
    </div>
</template>

<script>
import SharePopup from "@/components/SharePopup.vue";
import { getUserCartProdCount } from "@/api/account";
export default {
    name: "detail",
    components: { SharePopup },
    props: ["pid"],
    data () {
        return {
            showPopover: false,
            actions: [
                { text: "首页" },
                { text: "我的订单" },
                // { text: "分享" },
            ],
            proId: 0,
            loading: true,
            showChoise: false,
            product: {},
            skuSelected: false,
            confirm: false,
            actionType: 1, //1:立即购买 2：加入购物车
            salable: false,
            share: false,
            share2: false,
            sku: {
                count: 1,
                skuId: 0,
                skuName: "",
                skuPrice: 0,
                skuOriginalPrice: 0,
                remain: 0,
            },
        };
    },
    created () {
        this.loadDetail();
    },
    activated () {
        this.loadDetail();
    },
    computed: {
        cartCount () {
            return this.$store.state.cartCount;
        }
    },
    methods: {
        loadDetail () {
            this.$toast.loading({
                message: "加载中...",
                forbidClick: true
            });
            this.$ajax.get("api/product/" + this.pid).then((response) => {
                if (response.data.code === 1) {
                    if (response.data.data) {
                        this.initSkuSelect(response.data.data.ProSkuList);
                        this.product = response.data.data;
                        //保存商品信息
                        localStorage.setItem(
                            "goods-info",
                            JSON.stringify(this.product)
                        );
                    } else {
                        //无商品信息
                        this.$router.push({ name: "home" });
                    }
                    this.loading = false;
                } else {
                    //获取商品失败
                }
                this.$toast.clear();
            });
        },
        goBuy () {
            this.confirm = true;
            this.showChoise = true;
            this.actionType = 1;
        },
        //加入购物车
        addCart () {
            this.confirm = true;
            this.showChoise = true;
            this.actionType = 2;
        },
        confirmBuy () {
            if (this.sku.skuId === 0) {
                this.$toast("请选择规格");
                return;
            }
            //确认购买，跳转到结算页面
            if (this.actionType == 1) {
                this.$router.push({
                    name: "checkout",
                    query: {
                        sku: this.sku.skuId,
                        count: this.sku.count,
                        pid: this.product.ProId,
                    },
                });
            }
            else if (this.actionType == 2 && this.product.ProType === 1) {
                this.$toast.loading({
                    duration: 0,
                    message: "加入购物车中...",
                    forbidClick: true
                });
                this.$ajax
                    .post("api/cart/changeItem", {
                        prodId: this.product.ProId,
                        stockid: this.sku.skuId,
                        count: this.sku.count
                    })
                    .then((response) => {
                        if (response.data.code === 1) {
                            this.$toast.clear();
                            this.showChoise = false;
                            getUserCartProdCount();
                        } else {
                            this.$toast(response.data.message);
                        }
                    });
            }

        },
        confirmSku () {
            this.showChoise = true;
        },
        onClose () {
            this.confirm = false;
        },
        //选择规格
        selectSku (item) {
            if (!this.isDisabled(item)) {
                this.sku.skuId = item.StockId;
                this.sku.skuName = item.StockName;
                this.sku.skuPrice = item.StockPrice;
                this.sku.skuOriginalPrice = item.OriginalPrice;
                this.sku.remain = item.StockCount;
                this.skuSelected = true;
            }
        },
        //初始化默认选择
        initSkuSelect (skus) {
            let inited = false;
            this.sku.skuName = "";
            this.sku.skuId = 0;
            this.sku.skuPrice = 0;
            this.sku.skuOriginalPrice = 0;
            this.sku.remain = 0;
            this.skuSelected = false;
            if (skus.length > 0) {
                for (let i = 0; i < skus.length; i++) {
                    let item = skus[i];
                    //console.log(item.StockName);
                    if (!this.isDisabled(item)) {
                        // if (this.sku.skuId != item.StockId) {
                        // }
                        this.sku.count = this.product.MinNum;
                        // this.sku.skuId = item.StockId;
                        // this.sku.skuName = item.StockName;
                        // this.sku.skuPrice = item.StockPrice;
                        inited = true;
                        this.salable = true; //有可售
                        break;
                    }
                }
                //无可售
                if (!inited) {
                    this.salable = false;
                    this.skuSelected = false;
                    // this.sku.skuId = skus[0].StockId;
                    // this.sku.skuName = skus[0].StockName;
                    // this.sku.skuPrice = skus[0].StockPrice;
                    // this.sku.count = this.product.MinNum;
                }
            } else {
                this.salable = false;
                this.skuSelected = false;
            }
        },
        isActive (skuId) {
            return this.sku.skuId === skuId;
        },
        isDisabled (skuItem) {
            if (skuItem.StockCount === 0 || skuItem.StockStatus !== 1)
                return true;
            else return false;
        },
        //分享
        showShare () {
            this.share = true;
        },
        showPop () {
            this.showPopover = true;
        },
        popSelect (action) {
            this.showPopover = false;
            if (action.text === "我的订单") {
                this.$router.push("/order/0");
            } else if (action.text === "分享") {
                this.share = true;
            } else if (action.text === "首页") {
                this.$router.push({ name: "home" });
            }
        },
    },
};
</script>

<style lang="less" scoped>
.bg {
    background: #fff;
}

.swipe-h {
    //min-height: 300px;
    max-height: 640px;
}

.swipe-h img {
    display: block;
    // height: 100%;
    max-width: 100%;
    max-height: 100%;
    margin: 0 auto;
}

.section {
    position: relative;
}

.section-border {
    border-top: 10px solid #f5f5f5;
}

.section-padding {
    padding: 0 15px;
}

.cell-tit {
    color: rgba(0, 0, 0, 0.54);
    display: inline-block;
    margin-right: 10px;
}

.cell-value {
    display: inline-block;
}

.header {
    height: 50px;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 10;
    padding: 0 15px;
}

.header .header-btn {
    display: block;
    width: 32px;
    height: 32px;
    color: #ddd;
    background: rgba(0, 0, 0, 0.6);
    border-radius: 50%;
    line-height: 34px;
    text-align: center;
    font-size: 20px;
}

.header-btn-margin-l {
    margin-left: 10px;
}

.header-btn-margin-r {
    margin-right: 10px;
}

.header-btn-margin-r5 {
    margin-right: 5px;
}

.header .header-center {
    flex: 1;
}

.goods-name {
    font-size: 18px !important;
    padding-top: 15px;
}

.goods-intro {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.54);
    margin-top: 5px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
}

.goods-price {
    color: #ff6700;
    font-size: 22px;
    padding: 10px 0;
}

.goods-price .suffix {
    font-size: 12px;
    display: inline-block;
    margin: 0 3px;
}

.goods-price .price {
    font-weight: 600;
}


.goods-price .unprice {
    font-weight: normal;
    font-size: 18px;
    color: #969799;
    text-decoration: line-through;
}

.goods-tag {
    margin-left: 10px;
}

.goods-desc {
    padding: 10px 10px 0 10px;

    /deep/ iframe {
        width: 100%;
    }

    /deep/ img {
        margin-left: -10px;
        margin-right: -10px;
        max-width: calc(100% + 20px);
        margin-bottom: -4px;
    }
}

.goods-actions {
    padding: 5px 0;
}

.sku-container {
    display: flex;
    //   max-height: max-content;
    font-size: 14px;
    align-items: stretch;
    flex-direction: column;
    background-color: #fff;
    height: 100%;
}

.sku-header {
    margin-left: 16px;
    display: flex;
    flex-direction: row;
}

.sku-header-price {
    font-size: 22px;
    color: #f44;
}

.sku-header-unprice {
    font-size: 16px;
    color: #969799;
    text-decoration: line-through;
    margin-left: 5px;
}


.sku-header-item {
    font-size: 12px;
    line-height: 16px;
    margin-top: 5px;
    color: #969799;
}

.sku-img {
    position: relative;
    height: 96px;
    width: 96px;
    border-radius: 5px;
    margin: 12px 0;
    background: #f8f8f8;
}

.sku-img img {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    max-height: 100%;
    max-width: 100%;
    margin: auto;
    border-radius: 5px;
}

.sku-goods-info {
    flex: 1;
    min-height: 96px;
    padding: 12px 36px 12px 8px;
    overflow: hidden;
}

.sku-close-icon {
    position: absolute;
    top: 12px;
    right: 16px;
    color: #dcdde0;
    font-size: 20px;
    text-align: center;
}

.sku-btns {
    background: #fff;
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    padding: 10px 20px;
}

.sku-body {
    flex: 1 1 auto;
    overflow-y: auto;
    padding-bottom: 80px;
}

.sku-stock-container {
    margin-left: 16px;
    padding: 12px 0 2px;
}

.sku-row {
    margin: 0 3px 12px 0;
}

.sku-row:last-child {
    margin-bottom: 0;
}

.sku-row-tit {
    padding-bottom: 12px;
}

.sku-row-item {
    display: inline-flex;
    margin: 0 12px 12px 0;
    padding: 8px;
    font-size: 13px;
    line-height: 16px;

    min-width: 40px;
    border-radius: 4px;
    position: relative;
    background-color: #f7f8fa;
}

.sku-row-item--active {
    color: #f44;
    background-color: #ffecec;
    border: 1px solid #f44;
}

.sku-row-item--disabled {
    color: #c8c9cc;
    background: #f2f3f5;
}

.sku-stepper-container {
    margin-left: 16px;
    padding: 12px 0;
}

.sku-stepper-stock {
    height: 30px;
    margin-right: 20px;
}

.sku-stepper-tit {
    float: left;
    line-height: 30px;
}

.sku-stepper {
    float: right;
}
</style>
